import axios, { type AxiosInstance } from 'axios';
import type { App, InjectionKey } from 'vue';

export const httpKey = Symbol('http') as InjectionKey<AxiosInstance>;

export function createHttpPlugin() {
  const http: AxiosInstance = axios.create({
    baseURL: import.meta.env.VITE_API_BASEURL,
  });

  return {
    http, // expose instance for Pinia plugin wiring
    install(app: App) {
      const auth0 = app.config.globalProperties.$auth0;

      http.interceptors.request.use(async (config) => {
        // Important: don't trigger login redirects from here
        const token = await auth0.getAccessTokenSilently();
        config.headers = config.headers ?? {};
        config.headers.Authorization = `Bearer ${token}`;
        return config;
      });

      app.provide(httpKey, http);
      app.config.globalProperties.$http = http; // optional
    },
  };
}
